export default __webpack_public_path__ + "static/media/SD-logo-02.fa2d8e51.jpg";